module.exports = __webpack_public_path__ + "2273e3d8ad9264b7daa5bdbf8e6b47f8.png";


//////////////////
// WEBPACK FOOTER
// ./~/leaflet/dist/images/marker-icon.png
// module id = 56
// module chunks = 0